export default "__VITE_ASSET__Cxg$oIcB__"